import Container from '../common/Container';

export default function ScrollLink({ serviceLink, handleScroll }) {
  return (
    <Container>
      <div className="overflow-y-auto" id="innerScroll">
        <ul
          // style={{
          //   background: ``,
          // }}
          className="goog py-[30px] grid lg:grid-cols-8 md:grid-cols-4 grid-cols-1 text-center lg:gap-10 gap-5 bg-[linear-gradient(90deg,_#010816_4.77%,_#0643A9_54.19%,_#000815_104.4%)]"
        >
          {serviceLink?.map(link => (
            <li key={link?.id}>
              <button
                onClick={e => {
                  link?.link && handleScroll(link?.link, e);
                  e.preventDefault();
                }}
                // href={`${link?.link}`}
                className="table_content cursor-pointer text-[16px] font-[500] text-[#f5f5f5] inline-block p-0"
              >
                {link?.text}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
}
